module.exports = __webpack_public_path__ + "static/media/sun.93f45d9b.png";